//LIBRERIE
import React, { useEffect, useRef } from "react";

const PoligonBg: React.FC = () => {

   const poligon = useRef<HTMLDivElement>(null);

   const createPoligon = () => {
        const coordinateXRandom = Math.floor(Math.random() * window.innerWidth);
        const coordinateYRandom = Math.floor(Math.random() * window.innerHeight);

        if(poligon.current != null){
            poligon.current.style.left = coordinateXRandom+'px';
            poligon.current.style.top = coordinateYRandom+'px';
        }
    };

    useEffect(() => {
        setInterval(createPoligon, 10000);
    },[])

    return(
        <div id="poligonBg" ref={poligon}></div>
    )
};
export default PoligonBg;